<template>
  <div id="app">
      <aside-panel></aside-panel>

      <div class="projects">
        <h2>I work(ed) on this projects.</h2>
        <project
          v-for="(project, index) in projects"
          :key="index"
          :project="project"
          :position="index + 1"
        ></project>
      </div>

      <footer v-once>
        &copy; {{ new Date().getFullYear() }} - jakubkotek.cz
      </footer>
  </div>
</template>

<script>
import AsidePanel from "./components/AsidePanel.vue";
import Project from "./components/Project.vue";

import projects from "./projects.js";

export default {
  name: "app",

  components: {
    AsidePanel,
    Project
  },

  data() {
    return {
      projects
    };
  }
};
</script>

<style>
html {
  font-family: "Oswald", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
  font-size: 16px;
  color: #323232;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
ol,
ul {
  margin: 0;
  padding: 0;
  font-weight: normal;
}

ol,
ul {
  list-style: none;
}

img {
  max-width: 100%;
  height: auto;
}

:root {
  --primary: #4030e8;
  --primary-light: #aaa3f5;
  --vue: #42b983;
  --react: #61dafb;
  --nette: #aa8908;
  --laravel: #f4645f;
}
::-webkit-scrollbar {
  width: 12px;
}
::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
::-webkit-scrollbar-track {
  background: #fff;
  border: thin solid #ccc;
}
::-webkit-scrollbar-thumb {
  background: #aaaaaa;
  border: none;
  transition: 300ms;
}
::-webkit-scrollbar-thumb:hover {
  background: #999;
}
::-webkit-scrollbar-track-piece {
  background: #fff;
  border: none;
  border-left: 1px solid #ccc;
  box-shadow: none;
}

body {
  border-top: 4px solid var(--primary);
  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3E%3Cpath fill='%234030e8' fill-opacity='0.21' d='M1 3h1v1H1V3zm2-2h1v1H3V1z'%3E%3C/path%3E%3C/svg%3E");
}

a,
.primary {
  color: var(--primary);
  text-decoration: none;
}

#app {
  max-width: 1240px;
  padding: 40px 15px 60px 15px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

@media all and (max-width: 768px) {
  #app {
    display: block;
  }
}

aside {
  flex-basis: 22%;
}

.projects {
  flex-basis: 70%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

@media all and (max-width: 1240px) {
  .projects {
    flex-basis: 60%;
  }
}

@media all and (max-width: 768px) {
  .projects {
    margin-top: 50px;
  }
}

.projects h2 {
  flex-basis: 100%;
  margin-bottom: 30px;
}

footer {
  flex-basis: 100%;
  margin-top: 30px;
  text-align: center;
  color: #828282;
}
</style>
